// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__luEeW","footer":"ChangeClinic_footer__2WvUa"};